let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("f8c8f")]).then(() => parcelRequire('aABDg'));